import React, { useContext, useState } from 'react';
import { Row, Col, Switch, HeadingText, BodyText, TextInput, Button } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from './VaultSetupTokenConfigurator.module.less';

const VaultSetupShippingAddressForm = () => {
  const {
    VaultSetupTokenConfigurator: { updateVaultSetupOption }
  } = useContext(IntegrationPageSectionContext);
  const [sectionEnabled, enableSection] = useState(false);

  const [formData, updateFormData] = useState({
    fullName: '',
    addressLine1: '',
    adminArea2: '',
    adminArea1: '',
    postalCode: '',
    countryCode: ''
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    updateFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, addressLine1, adminArea2, adminArea1, postalCode, countryCode } = formData;
    const shippingData = {
      name: {
        full_name: fullName
      },
      address: {
        address_line_1: addressLine1,
        admin_area_2: adminArea2,
        admin_area_1: adminArea1,
        postal_code: postalCode,
        country_code: countryCode
      }
    };
    updateVaultSetupOption(shippingData, 'shipping');
  };

  const handleSwitchChange = () => {
    if (sectionEnabled) {
      updateVaultSetupOption(undefined, 'shipping');
    }
    enableSection(!sectionEnabled);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row className={styles.shipping_form_title_container}>
        <Col xs={11}>
          <HeadingText size="sm">Shipping information (optional)</HeadingText>
          <BodyText>If shipping is required, a user can pass their details in the order.</BodyText>
        </Col>
        <Col xs={1}>
          <Switch checked={sectionEnabled} onChange={handleSwitchChange} />
        </Col>
      </Row>
      {sectionEnabled && (
        <>
          <Row>
            <Col>
              <TextInput
                className={styles.customization_field}
                type="text"
                name="fullName"
                label="Full Name"
                value={formData.fullName}
                onChange={handleFormChange}
                autoComplete="full-name"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                className={styles.customization_field}
                type="text"
                name="addressLine1"
                label="Address Line 1"
                value={formData.addressLine1}
                onChange={handleFormChange}
                autoComplete="address-line-1"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                className={styles.customization_field}
                type="text"
                name="adminArea2"
                label="City"
                value={formData.adminArea2}
                onChange={handleFormChange}
                autoComplete="admin-area-2"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                className={styles.customization_field}
                type="text"
                name="adminArea1"
                label="State"
                value={formData.adminArea1}
                onChange={handleFormChange}
                autoComplete="admin-area-1"
                required
              />
              <TextInput
                className={styles.customization_field}
                type="text"
                name="postalCode"
                label="ZIP Code"
                value={formData.postalCode}
                onChange={handleFormChange}
                autoComplete="postal-code"
                required
              />
              <TextInput
                className={styles.customization_field}
                type="text"
                name="countryCode"
                label="Country Code"
                value={formData.countryCode}
                onChange={handleFormChange}
                autoComplete="country-code"
                required
              />
            </Col>
          </Row>
          <Button type="submit">Save Shipping Information</Button>
        </>
      )}
    </form>
  );
};

export default VaultSetupShippingAddressForm;
